<template>
    <span v-if="pending || !price || !priceString">—</span>
    <span v-else>{{ priceString }}</span>
</template>
<script>


import { stripePriceToString, debug } from '~/stripe.utils.mjs'


const log = debug('stripe:price*')

const intlFormatMap = new Map([
    ['en-US_EUR', new Intl.NumberFormat('en-US', { style: 'currency', minimumFractionDigits: 0, currency: 'EUR' })],
    ['fr-FR_EUR', new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })],
    ['runtime_EUR', new Intl.NumberFormat(undefined, { style: 'currency', currency: 'EUR' })],
])

export default {
    props: {
        price: Number,
        currency: { type: String, default: 'EUR' },
        locale: { type: String, default: 'en-US' },
        pending: Boolean
    },
    data: function () {
        return {
            log: console.log
        }
    },
    watch: {
        pending() {
            this.log('pending changed', this.pending)
        }
    },
    created() {
        this.log = debug(`stripe:price:${this._uid}*`)
    },
    computed: {
        intlFormater() {

            const intlKey = `${this.locale}_${this.currency}`

            let formater = intlFormatMap.get(intlKey)

            if (!formater) {
                this.log('initiating new formater', intlKey)
                formater = intlFormatMap.set(intlKey, new Intl.NumberFormat(this.local, { style: 'currency', currency: this.currency }))
            }

            return formater
        },
        priceString() {
            if (!this.price) { return }
            const p = this.price / 100;
            return this.intlFormater?.format(p).replaceAll(',', ' ');
            return stripePriceToString(this.price)
        }
    }
}</script>